<template>
  <div class="container">
    <div class="items grid-container grid-container--6-6">
      <div class="item col1" :class="{ error: error }">
        <div class="input-container">
          <input
            type="radio"
            :name="'option-' + $parent._uid"
            :id="'option-permanente-' + $parent._uid"
            value="permanente"
            @focus="onFocus"
            @blur="onBlur('permanente')"
            @click="$emit('click')"
            @input="$emit('input', $event.target.value)"
            :checked="value === 'permanente'"
            :required="required"
            :data-obfuscate="quantumObfuscate"
          />
          <label
            :for="'option-permanente-' + $parent._uid"
            :data-obfuscate="quantumObfuscate"
            >Permanente</label
          >
        </div>
      </div>
      <div class="item col2" :class="{ error: error }">
        <div class="input-container">
          <input
            type="radio"
            :name="'option-' + $parent._uid"
            :id="'option-temporal-' + $parent._uid"
            value="temporal"
            @focus="onFocus"
            @blur="onBlur('temporal')"
            @click="$emit('click')"
            @input="$emit('input', $event.target.value)"
            :checked="value === 'temporal'"
            :required="required"
            :data-obfuscate="quantumObfuscate"
          />
          <label
            :for="'option-temporal-' + $parent._uid"
            :data-obfuscate="quantumObfuscate"
            >Temporal</label
          >
        </div>
        <span class="error-temporal" v-if="value === 'temporal'">
          <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
          <p :data-obfuscate="quantumObfuscate">
            Para continuar con la contratación del producto, es necesario que
            poseas residencia permanente en el país
          </p>
        </span>
      </div>
    </div>
    <span class="error" v-if="error">
      <img src="@/assets/img/1x/error_icon.png" alt="Ícono error" />
      <p>{{ error }}</p>
    </span>
  </div>
</template>

<script>
export default {
  name: "ResidenceType",
  props: {
    value: String,
    name: String,
    required: Boolean,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onFocus() {
      /* Animar viewport para que el elemento quede arriba
      70 = alto de topbar + padding */
      window.scroll({
        top: this.$el.offsetTop - 70,
        left: 0,
        behavior: "smooth"
      });
    },
    onBlur() {
      this.$emit("onBlur");
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  div.item {
    margin-bottom: 24px;
  }
  div.item:last-child {
    margin-bottom: 0px;
  }
}

@media screen and (min-width: 600px) {
  div.item {
    margin-bottom: 0px;
  }
}

div.container {
  display: block;
  margin-bottom: 24px;
}

div.item {
  vertical-align: top;
}

/* optional styles, I'm using this for centering radiobuttons */
.input-container {
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  display: inline-flex;
  align-items: center;
  width: 100%;
  height: 56px;
}

/* Estilos del radio */
/* https://stackoverflow.com/questions/26270168/how-to-customize-radio-button-in-html */
input[type="radio"] {
  /* remove standard background appearance */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 24px;
  height: 24px;
  padding: 5px;
  /* background-color only for content */
  background-clip: content-box;
  border: 1px solid #666666;
  background-color: white;
  border-radius: 50%;
  margin-top: 0px;
  margin-right: 8px;
  margin-left: 13px;
  cursor: pointer;
}

label {
  cursor: pointer;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}

/* appearance for checked radiobutton */
input[type="radio"]:checked {
  background-color: #004481;
}

input[type="radio"]:focus {
  outline: none;
}

input[type="radio"]:checked + label {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

/* Estilo para errores */
div.item.error {
  background: #fcdfdf;
}

span.error {
  margin-left: 16px;
  margin-top: 8px;
  display: block;
}

span.error-temporal {
  margin-top: 8px;
  margin-left: 16px;
  display: flex;
  align-items: flex-start;
}

span > img,
span > p {
  display: inline-block;
  vertical-align: top;
}

span > img {
  width: 16px;
}

span > p {
  margin-left: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #121212;
}
</style>
